import {
    createRegisterableComponentWithData,
    CurationAndCurationMetadataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { DevelopingNews } from './DevelopingNews'

export interface DevelopingNewsRouteProps {}

export const DevelopingNewsRegistration = createRegisterableComponentWithData(
    'developing-news',
    CurationAndCurationMetadataLoader,
    (props: DevelopingNewsRouteProps, data, services) => {
        if (data.loaded && data.result.articles.length > 0) {
            return (
                <DevelopingNews
                    item={data.result.articles}
                    headLine={data.result.metadata['developing-news-headline']}
                    onEvent={services.onEvent}
                />
            )
        }
        return null
    },
)
